/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import Code from 'components/Code';
import Table, {Row, Column} from 'components/Table';
function _createMdxContent(props) {
  const _components = Object.assign({
    h3: "h3",
    code: "code",
    p: "p",
    ol: "ol",
    li: "li",
    blockquote: "blockquote",
    pre: "pre",
    a: "a"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.h3, {
      children: [_jsx(_components.code, {
        children: "keyframes"
      }), "(", _jsx(_components.code, {
        children: "keyframes"
      }), ")"]
    }), "\n", _jsx(_components.p, {
      children: "| web-only"
    }), "\n", _jsx(_components.p, {
      children: "创建动画关键帧的辅助方法。"
    }), "\n", _jsx(_components.p, {
      children: "¥A helper method to create keyframes for animations."
    }), "\n", _jsx(Table, {
      head: ['Arguments', 'Description'],
      children: _jsxs(Row, {
        children: [_jsx(Column, {
          children: _jsxs(_components.ol, {
            children: ["\n", _jsxs(_components.li, {
              children: ["\n", _jsx(Code, {
                children: "TaggedTemplateLiteral"
              }), "\n"]
            }), "\n"]
          })
        }), _jsx(Column, {
          children: _jsx(_components.p, {
            children: "A tagged template literal with your keyframes inside."
          })
        })]
      })
    }), "\n", _jsxs(_components.p, {
      children: ["返回要在动画声明中使用的关键帧模型。如果你希望获取生成的动画名称，可以在返回的模型上使用 ", _jsx(_components.code, {
        children: "getName()"
      }), " API。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Returns a Keyframes model, to be used in your animation declarations. You can use the ", _jsx(_components.code, {
        children: "getName()"
      }), " API on the returned model if you wish to obtain the generated animation name."]
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsxs(_components.p, {
        children: ["在 styled-components v3 及以下版本中，", _jsx(_components.code, {
          children: "keyframes"
        }), " 辅助程序直接返回动画名称，而不是使用 ", _jsx(_components.code, {
          children: "getName"
        }), " 方法返回对象。"]
      }), "\n", _jsxs(_components.p, {
        children: ["¥In styled-components v3 and below, the ", _jsx(_components.code, {
          children: "keyframes"
        }), " helper directly returned the animation name instead of an object with the ", _jsx(_components.code, {
          children: "getName"
        }), " method."]
      }), "\n"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "import styled, { keyframes } from 'styled-components'\n\nconst fadeIn = keyframes`\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n`\n\nconst FadeInButton = styled.button`\n  animation: 1s ${fadeIn} ease-out;\n`\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["如果你将样式规则编写为部分样式，请确保使用 ", _jsx(_components.code, {
        children: "css"
      }), " 辅助程序。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥If you are composing your style rule as a partial, make sure to use the ", _jsx(_components.code, {
        children: "css"
      }), " helper."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "import styled, { css, keyframes } from 'styled-components'\n\ninterface AnimationProps {\n  $animationLength: number;\n}\n\nconst pulse = keyframes`\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n`\n\nconst animation = props =>\n  css<AnimationProps>`\n    ${pulse} ${props.$animationLength} infinite alternate;\n  `\n\nconst PulseButton = styled.button<AnimationProps>`\n  animation: ${animation};\n`\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["你可以在 ", _jsx(_components.a, {
        href: "/docs/basics#animations",
        children: "动画"
      }), " 部分了解有关使用带有样式组件的动画的更多信息。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥You can learn more about using animations with styled-components in the ", _jsx(_components.a, {
        href: "/docs/basics#animations",
        children: "Animations"
      }), " section."]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
